var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.incentive || _vm.route.children === undefined
    ? _c(
        "VListTile",
        {
          attrs: { to: _vm.routeTarget, disabled: _vm.disabled },
          nativeOn: {
            mouseenter: function ($event) {
              return _vm.onMouseEnter($event, _vm.route)
            },
            mouseleave: function ($event) {
              return _vm.onMouseLeave.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "VListTileAction",
            { staticClass: "action-centered" },
            [_c("KmIcon", { attrs: { name: _vm.route.meta.icon } })],
            1
          ),
          _vm._v(" "),
          _c(
            "VListTileContent",
            [
              _c("VListTileTitle", [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "VListGroup",
        { attrs: { noAction: "" } },
        [
          _c(
            "VListTile",
            {
              attrs: { slot: "activator", to: _vm.routeTarget },
              nativeOn: {
                mouseenter: function ($event) {
                  return _vm.onMouseEnter($event, _vm.route)
                },
                mouseleave: function ($event) {
                  return _vm.onMouseLeave.apply(null, arguments)
                },
              },
              slot: "activator",
            },
            [
              _c(
                "VListTileAction",
                { staticClass: "action-centered" },
                [_c("KmIcon", { attrs: { name: _vm.route.meta.icon } })],
                1
              ),
              _vm._v(" "),
              _c("VListTileContent", [_vm._v(_vm._s(_vm.title))]),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.route.children, function (childRoute) {
            return _c(
              "VListTile",
              {
                key: childRoute.name,
                staticClass: "child-link",
                attrs: { to: { name: childRoute.name } },
                nativeOn: {
                  mouseenter: function ($event) {
                    return _vm.onMouseEnter($event, childRoute)
                  },
                  mouseleave: function ($event) {
                    return _vm.onMouseLeave.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "VListTileAction",
                  [_c("KmIcon", { attrs: { name: childRoute.meta.icon } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "VListTileContent",
                  [
                    _c("VListTileTitle", [
                      _vm._v(
                        "\n        " +
                          _vm._s(childRoute.meta.title) +
                          "\n      "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }